module.exports = "/assets/data/1324535cf18a5c611dc372bc7aab50e5-RG45.data.json";